import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { DIRECTIONS } from "react-with-direction/dist/constants";
import DirectionProvider from "react-with-direction/dist/DirectionProvider";
import SayyehBan from "./sayyehban";
function App() {
  useEffect(() => {
    async function fetchMyAPI() {
      require("../utility/js/menu");
    }
    fetchMyAPI();
  }, []);
  return (
    <DirectionProvider direction={DIRECTIONS.RTL}>
      <BrowserRouter>
        <SayyehBan />
        <ToastContainer icon={false} />
      </BrowserRouter>
    </DirectionProvider>
  );
}
export default App;
